export const trackSignupPageView = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "signup_page_view",
    page_title: "Join Paartner Signup",
    page_location: window.location.href,
  });
};

export const trackFormInteraction = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "signup_form_interaction",
  });
};

export const trackSignupFormSubmit = (
  selected,
  referralCode,
  formData,
  duration
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "signup_form_submit",
    form_id: "join-paartner",
    member_type: selected,
    referral_code: referralCode || "",
    fields_count: Object.keys(formData).length,
    signup_duration_ms: Math.round(duration),
  });
};


export const trackReferralSubmitted = (vendorId) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "referral_submitted",
    vendor_id: vendorId || "",
    page_location: window.location.href,
  });
};


export const trackVendorPageViewed = (vendorId, vendorName) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "vendor_page_viewed",
    vendor_id: vendorId,
    vendor_name: vendorName || "",
    page_location: window.location.href,
  });
};
